'use client';

import { Minus, Plus } from '@zoomit/icons';
import { Col, Flex } from '@zoomit/primitives';
import { cssVar, theme, Typography } from '@zoomit/zoomit-ds';

type Props = {
  pros: string;
  cons: string;
};

const OverviewProsCons = ({ pros, cons }: Props) => {
  return (
    <Flex className="md:mr-4" gap={2.4} justifyContent={'space-between'} md={[{ gap: 0 }]}>
      {pros && (
        <Col
          className="before:bg-grey6 after:bg-success1 relative mr-4 pr-4 before:absolute before:top-0 before:-right-4 before:h-full before:w-0.5 after:absolute after:top-0 after:-right-4 after:z-[2] after:h-7 after:w-0.5 md:!m-0"
          size={12}
          md={6}
        >
          <Typography tag="div" fontWeight="bold" fontSize={1.8} textColor={cssVar(theme.success1)}>
            نکات مثبت{' '}
          </Typography>
          <ul className="not:last-child:mb-1 mt-2 pl-4">
            {pros.split(/\n/).map((item, index) => (
              <li className="flex list-none items-baseline gap-2" key={index}>
                <Plus size="xs" fill={cssVar(theme.success1)} />
                <Typography variant="body" lineHeight={2}>
                  {item}
                </Typography>
              </li>
            ))}
          </ul>
        </Col>
      )}
      {cons && (
        <Col
          className="before:bg-grey6 after:bg-error relative mr-4 pr-4 before:absolute before:top-0 before:-right-4 before:h-full before:w-0.5 after:absolute after:top-0 after:-right-4 after:z-[2] after:h-7 after:w-0.5 md:!m-0"
          spacing={{ mr: 'x8' }}
          size={12}
          md={6}
        >
          <Typography tag="div" fontWeight="bold" fontSize={1.8} textColor={cssVar(theme.error)}>
            نکات منفی
          </Typography>
          <ul className="not:last-child:mb-1 mt-2 pl-4">
            {cons.split(/\n/).map((item, index) => (
              <li className="flex list-none items-baseline gap-2" key={index}>
                <Minus size="xs" fill={cssVar(theme.error)} />
                <Typography variant="body" lineHeight={2}>
                  {item}
                </Typography>
              </li>
            ))}
          </ul>
        </Col>
      )}
    </Flex>
  );
};

export default OverviewProsCons;
